import React from "react";
import parseHtml from "html-react-parser";
import styles from "../../style/layout_components/Step1.module.scss";

const RichText = (props) => {
  return (
    <div>
      <section id="richtext_id" className={styles.content}>
        {props.fields.Title && <h2 className={styles.header}>{props.fields.Title.value}</h2>}
        {props.fields.Body && parseHtml(props.fields.Body.value)}
      </section>
    </div>
  );
};

export default RichText;
